import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminProtectedRoute from './components/AdminProtectedRoute';
import DashboardLayout from './components/DashboardLayout';
import AdminLayout from './components/AdminLayout';
import SdkLayout from './components/SdkLayout';

// Pages
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import SessionExpiredPage from './pages/SessionExpiredPage';
import DashboardPage from './pages/DashboardPage';
import ApiKeysPage from './pages/ApiKeysPage';
import AppsPage from './pages/AppsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import WebhooksPage from './pages/WebhooksPage';
import BillingPage from './pages/BillingPage';
import QuickStartPage from './pages/QuickStartPage';
import SettingsPage from './pages/SettingsPage';
import DeveloperTokensPage from './pages/DeveloperTokensPage';

// Admin Pages
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminOverviewPage from './pages/admin/AdminOverviewPage';
import AdminDevelopersPage from './pages/admin/AdminDevelopersPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminUsageLogsPage from './pages/admin/AdminUsageLogsPage';
import AdminMetricsPage from './pages/admin/AdminMetricsPage';

// SDK Documentation Pages
import SdkOverviewPage from './pages/sdk/SdkOverviewPage';
import SdkReferencePage from './pages/sdk/SdkReferencePage';

// Legal Pages
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/session-expired" element={<SessionExpiredPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />

          {/* SDK Documentation routes */}
          <Route path="/sdk" element={<SdkLayout />}>
            <Route index element={<SdkOverviewPage />} />
            <Route path=":slug" element={<SdkReferencePage />} />
          </Route>

          {/* Protected dashboard routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="api-keys" element={<ApiKeysPage />} />
            <Route path="apps" element={<AppsPage />} />
            <Route path="developer-tokens" element={<DeveloperTokensPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
            <Route path="webhooks" element={<WebhooksPage />} />
            <Route path="billing" element={<BillingPage />} />
            <Route path="quickstart" element={<QuickStartPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          {/* Admin login — separate UX, no layout wrapper */}
          <Route path="/admin/login" element={<AdminLoginPage />} />

          {/* Admin routes — requires admins group */}
          <Route
            path="/admin"
            element={
              <AdminProtectedRoute>
                <AdminLayout />
              </AdminProtectedRoute>
            }
          >
            <Route index element={<AdminOverviewPage />} />
            <Route path="developers" element={<AdminDevelopersPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="usage-logs" element={<AdminUsageLogsPage />} />
            <Route path="metrics" element={<AdminMetricsPage />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
